import GlobalModal from "../../../DirectCardSend/assets/GlobalModal";

const LinkFile = {
    'modal': GlobalModal
}
export default LinkFile;